import { render, staticRenderFns } from "./AccessLogReport.vue?vue&type=template&id=966b5afc"
import script from "./AccessLogReport.vue?vue&type=script&lang=js"
export * from "./AccessLogReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports